// Vuex module — Pemantauan Penerimaan (P26_0035 FR-16).
//
// Halaman /offline-stores/pos-receipt. Endpointnya di routes/routes/unionweb.php grup
// `/pos-receipt`, dijaga auth:api + access (modul `posreceipt_*`). Baca saja: sumbernya
// laporan yang didorong toko, dan tahapan tidak dihitung di sini [B.2].
import $axios from "../../api";

const PREFIX = "unionweb/pos-receipt";

const emptyPage = () => ({ data: [], total: 0, per_page: 20, from: 0, to: 0 });
const emptyCounts = () => ({ belum: 0, berjalan: 0, sudah: 0 });

const state = () => ({
  isLoading: false,
  list: emptyPage(),
  counts: emptyCounts(),
  page: 1,
});

const mutations = {
  SET_LOADING(s, v) {
    s.isLoading = v;
  },
  SET_LIST(s, v) {
    s.list = v?.shipments || emptyPage();
    s.counts = v?.counts || emptyCounts();
  },
  SET_PAGE(s, v) {
    s.page = v;
  },
};

const actions = {
  async getList({ commit, state, rootState, dispatch }, query = "") {
    commit("SET_LOADING", true);

    try {
      const res = await $axios.get(
        `${PREFIX}/list?page=${state.page}&view=${rootState.Main.view}${query}`
      );
      commit("SET_LIST", res.data?.data);
      return res.data;
    } catch (error) {
      commit("SET_LIST", null);
      dispatch("Main/globalSweetAlert", error.response || { message: "Unknown error" }, { root: true });
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  // Tidak disimpan di state: isinya milik satu modal.
  async getHistory(_ctx, { storeCode, shipmentUuid }) {
    const q = new URLSearchParams({ store_code: storeCode, shipment_uuid: shipmentUuid });
    const res = await $axios.get(`${PREFIX}/history?${q}`);
    return res.data?.data?.history || [];
  },

  async getStores() {
    const res = await $axios.get(`${PREFIX}/stores`);
    return res.data?.data?.stores || [];
  },
};

export default { namespaced: true, state, mutations, actions };
